module.exports = {
	init: function () {
		// List View
		$('.accordion-item .accordion-title').on('click', function (evt) {
			evt.preventDefault();
			$(this).parent().toggleClass('active');
			$(this)
				.parent()
				.find('.accordion-content')
				.slideToggle('3000', function () {
					// Animation complete.
				});
			if ($(this).attr('aria-expanded') === 'true') {
				$(this).attr('aria-expanded', 'false');
			} else {
				$(this).attr('aria-expanded', 'true');
			}
		});
	},
};
